<script setup lang="ts">
  import { Text } from '@ui-kit';
  import LoginPageFooter from './LoginPageFooter.vue';
</script>

<template>
  <LoginPageFooter data-testid="text-scan-barcode">
    <Text class="login-page__footer-title" font="heading-H4">{{ $t('Отсканируйте штрих-код') }}</Text>
    <Text class="login-page__footer-subtitle" font="body-regular-16">{{ $t('Для входа в приложение и начала работы') }}</Text>
    <svg class="scan-icon" width="196" height="52" viewBox="0 0 196 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M94 11H93" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M102 11H103" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M101.5 7.5L102 7" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M98 6L98 5" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M94 7L94.5 7.5" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M98 15L98 10" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M87 46V24C87 21.7909 88.7909 20 91 20H105C107.209 20 109 21.7909 109 24V46" stroke="#828690" stroke-width="2" stroke-linecap="round"/>
      <path d="M109 28H110C111.105 28 112 28.8954 112 30V34C112 35.1046 111.105 36 110 36H109V28Z" fill="#828690"/>
      <path d="M95 21L95 20C95 18.8954 95.8954 18 97 18L99 18C100.105 18 101 18.8954 101 20L101 21L95 21Z" fill="#828690"/>
      <rect x="97" y="23" width="2" height="2" rx="1" fill="#828690"/>
      <path d="M126 32H117M117 32L120.5 28.5M117 32L120.5 35.5" stroke="#828690" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <Text font="body-regular-12" color="secondary">{{ $t('Нажмите кнопку сбоку на сканере') }}</Text>
  </LoginPageFooter>
</template>

<style scoped>
  .scan-icon {
    margin-top: 24px;
  }

  .login-page__footer-title {
    color: #141414;
  }

  .login-page__footer-subtitle{
    color: #828690;
  }
</style>